/*
  ============================================================
  CUSTOM PRODUCT PAGE JS — assets/custom-product.js
  Palo Alto theme compatible
  ============================================================
*/

(function () {
  'use strict';

  function cpInit() {

    // ── Read product data ──
    const productDataEl = document.getElementById('cpProductData');
    if (!productDataEl) return;
    const productData = JSON.parse(productDataEl.textContent);
    const variants = productData.variants;

    // ── State ──
    let qty = 1;
    let selectedOptions = {};
    let currentVariant = null;

    // ── DOM refs ──
    const form          = document.getElementById('cpProductForm');
    const variantInput  = document.getElementById('cpVariantId');
    const priceEl       = document.getElementById('cpPrice');
    const compareEl     = document.getElementById('cpCompare');
    const saveEl        = document.getElementById('cpSave');
    const btnAtc        = document.getElementById('cpBtnAtc');
    const qnumEl        = document.getElementById('cpQnum');
    const shipWrap      = document.getElementById('cpShipBarWrap');
    const shipFill      = document.getElementById('cpShipBarFill');
    const shipMsgText   = document.getElementById('cpShipMsgText');
    const shipIcon      = document.getElementById('cpShipIcon');


    // ══════════════════════════════════════════════
    // 1. VARIANT SWITCHING
    // ══════════════════════════════════════════════

    document.querySelectorAll('.cp-sz.active, .cp-swatch.active').forEach(function (el) {
      const idx = el.dataset.optionIndex;
      if (idx !== undefined) selectedOptions[idx] = el.dataset.value;
    });

    function findVariant() {
      return variants.find(function (v) {
        return Object.keys(selectedOptions).every(function (idx) {
          const optKey = 'option' + (parseInt(idx) + 1);
          return v[optKey] === selectedOptions[idx];
        });
      }) || null;
    }

    function applyVariant(variant) {
      if (!variant) return;
      currentVariant = variant;
      if (variantInput) variantInput.value = variant.id;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      const priceFormatted = formatMoney(variant.price);
      if (priceEl) priceEl.textContent = priceFormatted;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        if (compareEl) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.style.display = ''; }
        if (saveEl)    { saveEl.textContent = 'SAVE ' + pct + '%'; saveEl.style.display = ''; }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (saveEl)    saveEl.style.display = 'none';
      }
      if (btnAtc) {
        if (variant.available) { btnAtc.textContent = 'Add to Cart'; btnAtc.disabled = false; }
        else { btnAtc.textContent = 'Sold Out'; btnAtc.disabled = true; }
      }
      const stockBar = document.querySelector('.cp-stock-bar');
      const stockStrong = document.getElementById('stockText');
      if (stockBar && stockStrong) {
        if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) {
          stockStrong.textContent = 'Only ' + variant.inventory_quantity + ' left';
          stockBar.style.display = 'flex';
        } else { stockBar.style.display = 'none'; }
      }
    }

    document.querySelectorAll('.cp-sz').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('oos') || btn.disabled) return;
        const idx = btn.dataset.optionIndex;
        selectedOptions[idx] = btn.dataset.value;
        document.querySelectorAll('.cp-sz[data-option-index="' + idx + '"]').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        applyVariant(findVariant());
      });
    });

    document.querySelectorAll('.cp-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        const idx = swatch.dataset.optionIndex;
        selectedOptions[idx] = swatch.dataset.value;
        document.querySelectorAll('.cp-swatch[data-option-index="' + idx + '"]').forEach(function (s) { s.classList.remove('active'); });
        swatch.classList.add('active');
        const colorLabel = document.getElementById('cpColorLabel');
        if (colorLabel) colorLabel.textContent = swatch.dataset.value;
        applyVariant(findVariant());
      });
    });


    // ══════════════════════════════════════════════
    // 2. QUANTITY CONTROLS
    // ══════════════════════════════════════════════

    const qtyInput  = document.getElementById('cpQtyInput');
    const minusBtn = document.getElementById('cpQtyMinus');
    const plusBtn  = document.getElementById('cpQtyPlus');

    function syncQtyInput() {
      if (qtyInput) qtyInput.value = qty;
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        if (qty > 1) { qty--; if (qnumEl) qnumEl.textContent = qty; syncQtyInput(); }
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        qty++; if (qnumEl) qnumEl.textContent = qty; syncQtyInput();
      });
    }


    // ══════════════════════════════════════════════
    // 3. ADD TO CART
    // The main ATC button adds only the main product variant.
    // The Complete the Look "Add selected items" button adds only the checked
    // look items. Both use cpCartAdd() which POSTs to /cart/add.js then calls
    // window.cart.getCart() — the theme's own method that re-renders the
    // cart drawer and dispatches theme:cart:added.
    // ══════════════════════════════════════════════

    function cpCartAdd(items, onStart, onDone, onError) {
      if (!items || items.length === 0) return;
      if (onStart) onStart();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { if (onError) onError(res.description || 'Error adding to cart'); return; }
          if (window.cart && typeof window.cart.getCart === 'function') {
            window.cart.getCart();
          }
          fetchCartAndUpdateShipBar();
          if (onDone) onDone();
        })
        .catch(function () { if (onError) onError('Something went wrong. Please try again.'); });
    }

    if (btnAtc) {
      btnAtc.addEventListener('click', function (e) {
        if (btnAtc.disabled) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        const vid = variantInput ? parseInt(variantInput.value, 10) : null;
        if (!vid) return;

        // Validate Avis Options fields (line item properties)
        var propInputs = document.querySelectorAll('input[name^="properties["], textarea[name^="properties["]');
        var missingCustomization = false;
        propInputs.forEach(function (input) {
          if (input.value.trim() === '') missingCustomization = true;
        });
        if (propInputs.length > 0 && missingCustomization) {
          showToast('Please enter your customization before adding to cart.');
          return;
        }

        // Collect any property values to include in cart add
        var properties = {};
        propInputs.forEach(function (input) {
          var match = input.name.match(/^properties\[(.+)\]$/);
          if (match) properties[match[1]] = input.value.trim();
        });

        const items = [{ id: vid, quantity: qty, properties: Object.keys(properties).length > 0 ? properties : undefined }];
        cpCartAdd(items,
          function () { btnAtc.textContent = 'Adding…'; btnAtc.disabled = true; },
          function () { btnAtc.textContent = 'Add to Cart'; btnAtc.disabled = false; },
          function (msg) { btnAtc.textContent = 'Add to Cart'; btnAtc.disabled = false; showToast(msg); }
        );
      });
    }

    /* Ship bar refresh after any cart update */
    document.addEventListener('theme:cart:added', fetchCartAndUpdateShipBar);

    function fetchCartAndUpdateShipBar() {
      if (!shipWrap) return;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { updateShipBar(cart.total_price); }).catch(function () {});
    }


    // ══════════════════════════════════════════════
    // 4. FREE SHIPPING BAR
    // ══════════════════════════════════════════════

    let threshold = 0;
    if (shipWrap) threshold = parseInt(shipWrap.dataset.threshold, 10) || 10000;

    function refreshShipBar(variantPriceCents) {
      if (!shipWrap) return;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        updateShipBar(cart.total_price + (variantPriceCents * qty));
      }).catch(function () { if (currentVariant) updateShipBar(currentVariant.price * qty); });
    }

    const shipProgressIconUrl = shipWrap ? (shipWrap.dataset.progressIconUrl || '') : '';
    const shipProgressText = shipWrap ? (shipWrap.dataset.progressText || "You're {amount} away from free shipping") : "You're {amount} away from free shipping";
    const shipCompleteIconUrl = shipWrap ? (shipWrap.dataset.completeIconUrl || '') : '';
    const shipCompleteText = shipWrap ? (shipWrap.dataset.completeText || "You've unlocked free shipping!") : "You've unlocked free shipping!";

    function makeIconHtml(url) {
      return url ? '<img src="' + url + '" alt="" width="20" height="20" style="vertical-align:middle;">' : '';
    }

    function updateShipBar(totalCents) {
      if (!shipWrap || !shipFill || !shipMsgText) return;
      const needed = Math.max(0, threshold - totalCents);
      const pct = Math.min(100, (totalCents / threshold) * 100);
      shipFill.style.width = pct.toFixed(1) + '%';
      if (needed === 0) {
        shipFill.classList.add('complete');
        if (shipIcon && shipCompleteIconUrl) shipIcon.innerHTML = makeIconHtml(shipCompleteIconUrl);
        shipMsgText.innerHTML = '<em>' + shipCompleteText + '</em>';
      } else {
        shipFill.classList.remove('complete');
        if (shipIcon && shipProgressIconUrl) shipIcon.innerHTML = makeIconHtml(shipProgressIconUrl);
        shipMsgText.innerHTML = shipProgressText.replace('{amount}', '<em>' + formatMoney(needed) + '</em>');
      }
    }

    if (shipWrap) fetchCartAndUpdateShipBar();


    // ══════════════════════════════════════════════
    // 5. SHOW MORE / SHOW LESS IMAGES
    // ══════════════════════════════════════════════

    (function () {
      var showMoreWrap = document.getElementById('cpShowMoreWrap');
      var showLessWrap = document.getElementById('cpShowLessWrap');
      var extraImgs    = document.getElementById('cpExtraImgs');
      if (!showMoreWrap || !extraImgs) return;

      document.getElementById('cpBtnShowMore').addEventListener('click', function () {
        extraImgs.classList.add('visible');
        showMoreWrap.classList.add('hidden');
        if (showLessWrap) showLessWrap.classList.add('visible');
      });

      if (showLessWrap) {
        document.getElementById('cpBtnShowLess').addEventListener('click', function () {
          extraImgs.classList.remove('visible');
          showMoreWrap.classList.remove('hidden');
          showLessWrap.classList.remove('visible');
        });
      }
    })();

    (function () {
      var mobShowMoreWrap = document.getElementById('cpMobShowMoreWrap');
      var mobShowLessWrap = document.getElementById('cpMobShowLessWrap');
      var stack           = document.querySelector('.cp-gallery-stack');
      var extraImgs       = document.getElementById('cpExtraImgs');
      if (!mobShowMoreWrap || !stack) return;

      document.getElementById('cpBtnMobShowMore').addEventListener('click', function () {
        stack.classList.add('mob-expanded');
        mobShowMoreWrap.classList.add('hidden');
        if (mobShowLessWrap) mobShowLessWrap.classList.add('visible');
        if (extraImgs) extraImgs.classList.add('visible');
      });

      if (mobShowLessWrap) {
        document.getElementById('cpBtnMobShowLess').addEventListener('click', function () {
          stack.classList.remove('mob-expanded');
          mobShowMoreWrap.classList.remove('hidden');
          mobShowLessWrap.classList.remove('visible');
          if (extraImgs) extraImgs.classList.remove('visible');
        });
      }
    })();


    // ══════════════════════════════════════════════
    // 6. COMPLETE THE LOOK — FETCH, RENDER, CHECKBOX
    // ══════════════════════════════════════════════

    const addAllBtn  = document.getElementById('cpLookAddAll');
    const lookTotalEl = document.getElementById('cpLookTotal');
    const lookPanel  = document.getElementById('cpLookPanel');
    const pairsEl    = document.getElementById('cpLookPairs');

    function getLookRows() {
      return document.querySelectorAll('#cpLookPairs .cp-look-row--check');
    }

    function updateLookTotal() {
      if (!lookTotalEl || !addAllBtn) return;
      const basePrice = parseInt(addAllBtn.dataset.basePrice, 10) || 0;
      let total = basePrice;
      let checkedCount = 0;
      getLookRows().forEach(function (row) {
        const cb = row.querySelector('.cp-look-checkbox');
        if (cb && cb.checked) { total += parseInt(row.dataset.price, 10) || 0; checkedCount++; }
      });
      lookTotalEl.textContent = formatMoney(total);
      addAllBtn.textContent = checkedCount > 0 ? 'Add ' + checkedCount + ' item' + (checkedCount > 1 ? 's' : '') + ' to cart' : 'Add to cart';
    }

    function initLookCheckboxes() {
      getLookRows().forEach(function (row) {
        row.addEventListener('click', function (e) {
          if (e.target.tagName === 'A') return;
          const cb = row.querySelector('.cp-look-checkbox');
          const cbBox = row.querySelector('.cp-look-cb');
          if (!cb) return;
          cb.checked = !cb.checked;
          if (cb.checked) { cbBox.classList.add('cp-look-cb--checked'); row.classList.remove('unchecked'); }
          else { cbBox.classList.remove('cp-look-cb--checked'); row.classList.add('unchecked'); }
          updateLookTotal();
        });
      });
      updateLookTotal();
    }

    if (lookPanel && pairsEl) {
      const collectionHandle  = lookPanel.dataset.collection;
      const currentProductId  = parseInt(lookPanel.dataset.productId, 10);
      const offset            = parseInt(lookPanel.dataset.offset, 10) || 0;
      const excludeTags  = (lookPanel.dataset.excludeTags  || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      const excludeTypes = (lookPanel.dataset.excludeTypes || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);

      if (collectionHandle) {
        fetch('/collections/' + collectionHandle + '/products.json?limit=250')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            let all = (data.products || []).filter(function (p) {
              if (p.id === currentProductId) return false;
              if (excludeTypes.length && p.product_type && excludeTypes.indexOf(p.product_type.toLowerCase()) > -1) return false;
              if (excludeTags.length && Array.isArray(p.tags) && p.tags.some(function (t) { return excludeTags.indexOf(t.toLowerCase()) > -1; })) return false;
              return true;
            });
            if (all.length === 0) { pairsEl.innerHTML = ''; return; }
            // Shuffle randomly
            for (let i = all.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [all[i], all[j]] = [all[j], all[i]];
            }
            const picks = all.slice(0, 3);
            pairsEl.classList.remove('cp-look-pairs-loading');
            pairsEl.innerHTML = picks.map(function (p) {
              const variant = p.variants && p.variants[0];
              if (!variant) return '';
              const img = p.images && p.images[0] ? '<img src="' + p.images[0].src + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '';
              const price = variant.price ? ('$' + parseFloat(variant.price).toFixed(2)) : '';
              const priceCents = variant.price ? Math.round(parseFloat(variant.price) * 100) : 0;
              const lookPanel = document.getElementById('cpLookPanel');
              const itemPriceSize = lookPanel ? (lookPanel.dataset.itemPriceSize || '16') : '16';
              return '<label class="cp-look-row cp-look-row--check" data-variant="' + variant.id + '" data-price="' + priceCents + '">'
                + '<div class="cp-look-row-cb"><input type="checkbox" class="cp-look-checkbox" checked><div class="cp-look-cb cp-look-cb--checked">✓</div></div>'
                + '<div class="cp-look-row-img">' + img + '</div>'
                + '<div class="cp-look-row-info"><div class="cp-look-row-name">' + p.title + '</div><div class="cp-look-row-price" style="font-size:' + itemPriceSize + 'px;">' + price + '</div></div>'
                + '</label>';
            }).join('');
            initLookCheckboxes();
          })
          .catch(function () { pairsEl.innerHTML = ''; });
      } else {
        pairsEl.innerHTML = '';
      }
    }

    if (addAllBtn) {
      addAllBtn.addEventListener('click', function () {
        const items = [];
        const mainVid = parseInt(addAllBtn.dataset.variantId, 10);
        if (mainVid) items.push({ id: mainVid, quantity: 1 });
        getLookRows().forEach(function (row) {
          const cb = row.querySelector('.cp-look-checkbox');
          if (cb && cb.checked) { const vid = row.dataset.variant; if (vid) items.push({ id: parseInt(vid, 10), quantity: 1 }); }
        });
        cpCartAdd(items,
          function () { addAllBtn.textContent = 'Adding…'; addAllBtn.disabled = true; },
          function () { addAllBtn.disabled = false; updateLookTotal(); },
          function (msg) { addAllBtn.disabled = false; updateLookTotal(); showToast(msg); }
        );
      });
    }


    // ══════════════════════════════════════════════
    // UTILITIES
    // ══════════════════════════════════════════════

    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) return Shopify.formatMoney(cents, '$ {{amount}}');
      return '$' + (cents / 100).toFixed(2);
    }

    function showToast(msg) {
      let toast = document.querySelector('.cp-toast');
      if (!toast) { toast = document.createElement('div'); toast.className = 'cp-toast'; document.body.appendChild(toast); }
      toast.textContent = msg;
      toast.classList.add('show');
      clearTimeout(toast._timer);
      toast._timer = setTimeout(function () { toast.classList.remove('show'); }, 2500);
    }

    currentVariant = findVariant() || variants[0];
    fetchCartAndUpdateShipBar();

    // ── Pull template sections added after this section into the left column ──
    (function () {
      var slot = document.getElementById('cpExtraContent');
      if (!slot) return;
      // Walk up to find the shopify-section wrapper for the custom product section
      var cpSection = slot.parentElement;
      while (cpSection && !(/^shopify-section/i.test(cpSection.id))) {
        cpSection = cpSection.parentElement;
      }
      if (!cpSection) return;
      var el = cpSection.nextElementSibling;
      while (el) {
        var next = el.nextElementSibling;
        // Stop at the footer section group
        if (/footer/i.test(el.id) || el.tagName === 'FOOTER') break;
        slot.appendChild(el);
        el = next;
      }
    })();

    // ── Set sticky offset for right panel (CSS handles the actual sticking) ──
    (function () {
      if (window.innerWidth <= 900) return;
      var root = document.documentElement;
      function setTop() {
        if (window.innerWidth <= 900) {
          root.style.removeProperty('--cp-sticky-top');
          return;
        }
        var hh = parseFloat(getComputedStyle(root).getPropertyValue('--header-height')) || 0;
        var ah = parseFloat(getComputedStyle(root).getPropertyValue('--announcement-height')) || 0;
        var headerH = hh + ah;
        if (headerH === 0) {
          var hdr = document.querySelector('header, .site-header, [data-section-type="header"]');
          headerH = hdr ? hdr.getBoundingClientRect().height : 0;
        }
        root.style.setProperty('--cp-sticky-top', headerH + 'px');
      }
      setTop();
      window.addEventListener('resize', setTop, { passive: true });
    })();


    // ══════════════════════════════════════════════
    // SMOOTH SCROLL — "See all reviews" anchor
    // ══════════════════════════════════════════════
    document.querySelectorAll('a[href="#cp-reviews"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.getElementById('cp-reviews');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    var judgeBadge = document.getElementById('cpJudgeBadge');
    if (judgeBadge) {
      judgeBadge.addEventListener('click', function (e) {
        var target = document.getElementById('cp-reviews');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }



  } // end cpInit


  // ── Run on page load and whenever the theme editor re-renders the section ──
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cpInit);
  } else {
    cpInit();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.cp-page')) cpInit();
  });


  // ══════════════════════════════════════════════
  // CTL MOVE — runs immediately, re-runs on resize
  // Moves .cp-look-in-gallery to info col on mobile
  // (≤768px) and large screens (≥1440px), back to
  // gallery col on standard desktop.
  // ══════════════════════════════════════════════
  function cpMoveCTL() {
    var lookEl     = document.querySelector('.cp-look-in-gallery');
    if (!lookEl) return;
    var galleryCol = document.querySelector('.cp-gallery-col');
    var infoCol    = document.getElementById('cpInfoCol');
    if (!galleryCol || !infoCol) return;

    function moveCTL() {
      var w = window.innerWidth;
      if (w >= 1440 || w <= 768) {
        if (lookEl.parentElement !== infoCol) infoCol.appendChild(lookEl);
      } else {
        if (lookEl.parentElement !== galleryCol) galleryCol.appendChild(lookEl);
      }
    }

    moveCTL();
    window.addEventListener('resize', moveCTL, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cpMoveCTL);
  } else {
    cpMoveCTL();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.cp-page')) cpMoveCTL();
  });


  // ══════════════════════════════════════════════
  // ACCORDION — global so Liquid onclick works
  // ══════════════════════════════════════════════

  window.cpToggleAcc = function (btn) {
    const body  = btn.nextElementSibling;
    const arrow = btn.querySelector('.cp-acc-arrow');
    const isOpen = body.classList.contains('open');
    body.classList.toggle('open', !isOpen);
    if (arrow) arrow.classList.toggle('open', !isOpen);
    btn.setAttribute('aria-expanded', String(!isOpen));
  };

})();
